import * as React from "react";
import Button from "@mui/joy/Button";
import Divider from "@mui/joy/Divider";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DialogActions from "@mui/joy/DialogActions";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DeleteForever from "@mui/icons-material/DeleteForever";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
// import { deleteCategory } from '../api/methods'; // Replace with actual import
import { deleteItem } from "../api/methods";

interface AlertDialogModalProps {
  item: "category" | "workorder";
  id: string;
  open: boolean;
  onClose: () => void;
  onDeleteSuccess: () => void;
}

const AlertDialogModal: React.FC<AlertDialogModalProps> = ({
  item,
  id,
  open,
  onClose,
  onDeleteSuccess
}) => {
  const handleDelete = async () => {
    try {
      await deleteItem(item, id);
      onDeleteSuccess();
      onClose();
    } catch (error) {
      console.error("Failed to delete category", error);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog variant="outlined" role="alertdialog">
        <DialogTitle>
          <WarningRoundedIcon />
          Confirmation
        </DialogTitle>
        <Divider />
        <DialogContent>
          Are you sure you want to delete this item?
        </DialogContent>
        <DialogActions>
          <Button variant="solid" color="danger" onClick={handleDelete}>
            Delete
          </Button>
          <Button variant="plain" color="neutral" onClick={onClose}>
            Cancel
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
};

export default AlertDialogModal;
